import { managementTestInstance } from '../axios';

const getMonitoringJobsFull = (ProcessStatus: any, pagination: any, sortOrder: any, DateFrom: any, DateTo: any) => 
  managementTestInstance.post('/monitoring-job-full', { ProcessStatus, pagination, sortOrder, DateFrom, DateTo });
const getMonitoringJobs = (ProcessStatus: any, pagination: any, sortOrder: any, DateFrom: any, DateTo: any) =>
  managementTestInstance.post('/monitoring-job-list', { ProcessStatus, pagination, sortOrder, DateFrom, DateTo });
const getMonitoringJobDetails = (MonitoringId: any, Task: any) => 
  managementTestInstance.post('/monitoring-job-details', { MonitoringId, Task });
const monitoringjobRestart = (MonitoringId: any, Task: any) =>
  managementTestInstance.post('/monitoring-job-details_restart', { MonitoringId, Task });
const addIntegrationRecipient = (IntegrationId: any, Task: any, RecipientName: any, RecipientEmail: any, NotifyWhen: any) =>
  managementTestInstance.post('/integration-recipients-add', { IntegrationId, Task, RecipientName, RecipientEmail, NotifyWhen });
const addMeRecipient = (MonitoringId: any, Task: any, NotifyWhen: any) =>
  managementTestInstance.post('/monitoring-notify-me', { MonitoringId, Task, NotifyWhen });
const getIntegrationJobList = (SearchString: any, pagination: any, sortOrder: any) =>
  managementTestInstance.post('/integration-job-list', { SearchString, pagination, sortOrder });
const updateIntegrationJob = (IntegrationId: any, SendNotification: any, SuccessEmailTemplate: any, FailedEmailTemplate: any) =>
  managementTestInstance.post('/integration-job-update', { IntegrationId, SendNotification, SuccessEmailTemplate, FailedEmailTemplate });
const getIntegrationJobSettings = (IntegrationId: any, pagination: any, sortOrder: any) =>
  managementTestInstance.post('/integration-job-settings', { IntegrationId, pagination, sortOrder });

export default {
  getMonitoringJobsFull,
  getMonitoringJobs,
  getMonitoringJobDetails,
  monitoringjobRestart,
  addIntegrationRecipient,
  addMeRecipient,
  getIntegrationJobList,
  updateIntegrationJob,
  getIntegrationJobSettings,
};
